/* Keep legacy product thumbnails connected with and without the Slick runtime. */
(() => {
  if (window.rhLegacyProductGalleryLoaded) return;
  window.rhLegacyProductGalleryLoaded = true;

  const init = (gallery) => {
    const main = gallery.querySelector('[data-image-gallery-main]');
    const strip = gallery.querySelector('.productView-for');
    if (!main || !strip || main.dataset.rhGalleryReady) return;

    const slides = Array.from(main.querySelectorAll('.productView-image:not(.slick-cloned)'));
    const items = Array.from(strip.querySelectorAll('.productView-thumbnail:not(.slick-cloned)')).map((thumbnail) => {
      const mediaId = (thumbnail.dataset.mediaId || '').split('-').pop();
      const slide = slides.find((item) => item.querySelector('[data-media-id]')?.dataset.mediaId === mediaId);
      const control = thumbnail.querySelector('.productView-thumbnail-link');
      return { mediaId, slide, control };
    }).filter((item) => item.slide && item.control);
    if (items.length < 2) return;
    main.dataset.rhGalleryReady = 'true';
    let active = items.find((item) => item.slide.classList.contains('slick-current')) || items[0];

    const align = () => {
      if (main.classList.contains('slick-initialized')) {
        // The native slider owns its transforms; use its API rather than scrolling its track.
        if (typeof window.jQuery === 'function') {
          const slider = window.jQuery(main);
          if (typeof slider.slick === 'function') slider.slick('slickGoTo', slides.indexOf(active.slide));
        }
        return;
      }
      // Scroll this viewport only, keeping full-resolution media and page position.
      const delta = active.slide.getBoundingClientRect().left - main.getBoundingClientRect().left - main.clientLeft;
      if (Math.abs(delta) > 1) main.scrollBy({ left: delta, behavior: 'instant' });
    };
    const select = (item) => {
      active = item;
      align();
      slides.forEach((slide) => {
        const selected = slide === item.slide;
        slide.setAttribute('aria-hidden', String(!selected));
        if (!selected) slide.querySelectorAll('video').forEach((video) => video.pause());
      });
      items.forEach((entry) => entry.control.setAttribute('aria-pressed', String(entry === item)));
    };

    items.forEach((item) => {
      const control = item.control;
      control.setAttribute('role', 'button');
      control.tabIndex = 0;
      control.setAttribute('aria-label', control.querySelector('img')?.alt || item.slide.querySelector('img')?.alt || item.mediaId);
      control.addEventListener('click', (event) => {
        event.preventDefault();
        select(item);
      });
      control.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          select(item);
        }
      });
    });

    gallery.closest('.productView')?.addEventListener('rh:variant-change', (event) => {
      const mediaId = String(event.detail?.variant?.featured_media?.id || '');
      const item = items.find((entry) => entry.mediaId === mediaId);
      if (item) select(item);
    });
    select(active);
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(align);
      observer.observe(main);
      const section = gallery.closest('.shopify-section');
      if (section) section.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
    }
  };

  const boot = () => document.querySelectorAll('.product-step-by-step [data-image-gallery]').forEach(init);
  // This async asset is emitted after the gallery markup; do not wait for unrelated deferred vendors.
  boot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  document.addEventListener('shopify:section:load', boot);
})();
